import React from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import Icon from "../../../common/icon/icon.component"
import LabelSelect from "../../../common/label/selection.component"
import IntlProps from "../../../state/helpers/IntlProps"

const messages = defineMessages({
    brand_description: {
        id: "product.form.components.product_brand_field.brand_description",
        defaultMessage: "Brands are used to classify products. They can be used in searches or filters."
    },
})

type OwnProps = {
    selectedbrandId: string
    onBrandSelectChange: () => void
}

const ProductBrandFieldSelect = (props: OwnProps & IntlProps) => {

    return <>
        <div className="mb-1 row">
            <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="brand">
                <FormattedMessage id="product.form.components.product_brand_field.brand_label" defaultMessage="Brand" />
                <span
                    className={"ml-auto"}
                    data-toggle="tooltip"
                    data-html="true"
                    title={props.intl.formatMessage(messages.brand_description)}
                >
                    <Icon value={"info-circle"} className={"ml-1"} />
                </span>
            </label>
            <div className="col-12">
                <LabelSelect
                    creatable={true}
                    type="brand"
                    name="brand"
                    value={props.selectedbrandId}
                    onChange={props.onBrandSelectChange}
                    multi={false}
                />
            </div>
        </div>
    </>
}

export default injectIntl(ProductBrandFieldSelect)


// WEBPACK FOOTER //
// ./src/product/form/components/ProductBrandFieldSelect.tsx